import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy
} from '@angular/core'
import { ContactFormComponent } from '../contact-form/contact-form.component'
import { ContactTableComponent } from '../contact-table/contact-table.component'
import { StaffContactComponent } from '../staff-contact/staff-contact.component'
import { environment } from 'environments/environment'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { ActivatedRoute } from '@angular/router'
import { AuthorizeService } from 'app/service/authorize.service'
import { isNullOrUndefined } from 'util'
import { BehaviorSubject, Subscription } from '../../../../node_modules/rxjs'
import { ExportExcelService } from '../../service/export-excel.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('contactForm') contactformComponent: ContactFormComponent

  @ViewChild(ContactTableComponent) contacttableComponent: ContactTableComponent
  @ViewChild(StaffContactComponent) staffcontactComponent: StaffContactComponent
  displayInputPage = true
  displayCreatePage = false
  displayEditPage = false
  displayComponent = false
  print = false
  pdf = false
  displayHeader = true
  printFirst = true
  printPage = false
  printListed = true
  printStaff = true
  isAE
  getPrint

  securitySymbol
  editId

  subscription: Subscription

  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService,
    private excelService: ExportExcelService
  ) { }

  reInitialTable() {
    this.contacttableComponent.getInformation(this.securitySymbol)
  }

  ngOnInit() {
    const { printCase, symbol } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print

    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf)
    print === undefined ? (this.print = false) : (this.print = print)

    if (printCase !== undefined) {
      if (printCase === 'true') {
        this.printListed = true
        this.printStaff = false
      } else if (printCase === 'false') {
        this.printListed = false
        this.printStaff = true
      }
    }

    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol)
    }

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(
        response => {
          // console.log('this.securitySymbol ==', this.securitySymbol)
          if (!response) {
            return
          }
          this.securitySymbol = response['securitySymbol']
          this.displayCreatePage = false
          this.displayComponent = true
          if (this.securitySymbol === null) {
            this.displayComponent = false
          }
        },
        error => {
          this.displayComponent = false
        }
      )

    if (this.print || this.pdf) {
      this.displayHeader = true
      this.printPage = true
      this.displayComponent = true
    } else {
      this.displayHeader = false
      this.printPage = false
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  editCaseHandler(event) {
    this.displayInputPage = false
    this.displayEditPage = true
    this.displayCreatePage = true
    this.editId = event.id
    this.contactformComponent.initFromGroup(event)
  }

  exportFunctionsForListedCompanyContact() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'email',
      this.exportEmailListed(this.securitySymbol, this.cpmService)
    )
    arrayOfFunctions.set('print', this.exportPrintListed(this.securitySymbol))
    arrayOfFunctions.set('pdf', this.exportPdfListed(this.securitySymbol))
    arrayOfFunctions.set('excel', this.exportExcelListed(this.excelService, this.contacttableComponent))
    return arrayOfFunctions
  }

  exportPrintListed = function (symbol) {
    return function contactPrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      const popupWin = window.open(
        `/#/contact/${endcodeSymbol}/true`,
        '_blank',
        'width=1200px,height=1024px'
      )
    }
  }

  exportPdfListed = function (symbol) {
    const service = this.cpmService
    return function contactPdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/contact?symbol=${endcodeSymbol}/true`
      )
    }
  }

  exportEmailListed = function (symbol, service) {
    return function contactMail() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.saveContactListedPdfFile(endcodeSymbol).then(filename => {
        const subject = 'Listed-Company-Contact'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }

  exportExcelListed = function (service, dataExcel) {
    return function excelListed() {
      service.exportExcelCompanyContact(dataExcel.dataExcelContact, 'Listed company contact')
    }
  }

  exportFunctionsForSetStaffContact() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'email',
      this.exportEmailStaff(this.securitySymbol, this.cpmService)
    )
    arrayOfFunctions.set('print', this.exportPrintStaff(this.securitySymbol))
    arrayOfFunctions.set('pdf', this.exportPdfStaff(this.securitySymbol))
    return arrayOfFunctions
  }

  exportPrintStaff = function (symbol) {
    return function staffPrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      const popupWin = window.open(
        `/#/contact/${endcodeSymbol}/false`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }

  exportPdfStaff = function (symbol) {
    const service = this.cpmService
    return function staffPdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/contact?symbol=${endcodeSymbol}/false`
      )
    }
  }

  exportEmailStaff = function (symbol, service) {
    return function staffMail() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.saveContactStaffPdfFile(endcodeSymbol).then(filename => {
        const subject = 'SET-Staff-Contact'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }

  addForm(event) {
    this.displayCreatePage = false
    this.contacttableComponent.getInformation(event)
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('CRM_CONTACT_VIEW') ||
      this.authorization.hasRole('CRM_CONTACT_EDIT')
    )
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 3000);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/contact/contact.component.ts